import { render, staticRenderFns } from "./live-event-stats.vue?vue&type=template&id=f653cc5a&scoped=true"
import script from "./live-event-stats.vue?vue&type=script&lang=js"
export * from "./live-event-stats.vue?vue&type=script&lang=js"
import style0 from "./live-event-stats.vue?vue&type=style&index=0&id=f653cc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f653cc5a",
  null
  
)

export default component.exports